<template>
  <div class="addmodal fixed w-full h-full z-20 top-0 left-0 flex justify-center items-start">
    <div class="bg-white m-auto w-96 flex flex-col rounded-md justify-center items-center">
        <h2 class="font-costea w-10/12 px-2 py-1 my-4 mx-auto border-b border-gray-200 text-left text-t20 font-medium text-costeaBlack">
            Editar categoría
        </h2>
        <form @submit.prevent="setGastos" class="flex flex-col justify-start w-full items-center">
            <div class="mb-4 px-2 py-2 flex flex-col content-center items-center w-10/12 rounded-md">
                <p class="w-full text-costeaGray items-center content-center text-t16 mb-3">Categoría: <span class="uppercase bg-gray-100 tracking-wider text-costeaGray italic p-1 rounded-md text-t14 font-bold">{{gastoOld}}</span></p>
                <label for="gastoNombre" class="w-full text-costeaGray items-center content-center text-t16 mb-2">Escriba el nuevo nombre:</label>
                <input type="text" id="gastoNombre" v-model="gastoNombre" required class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide mb-4" placeholder="Escriba el nombre">

                <label for="gastoMensual" class="w-full text-costeaGray items-center content-center text-t16 mb-2">Gasto:</label>
                <input type="number" min="0" max="999999999999" step="0.01" id="gastoMensual" v-model="gastoMensual" required class="bg-white placeholder-gray-300 border-gray-400 border outline-none font-costea px-2 p-3 text-t16 w-full rounded-md tracking-wide" placeholder="$0">
                
            </div>
            <div class="mb-3 p-3 flex content-center items-center w-10/12 rounded-md justify-around">
                <button class="bg-costeaBtn2 rounded-md text-costeaPrimary hover:bg-costeaBtn2Hover duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t14 uppercase tracking-wide" @click="toggleModal()" type="button">Cancelar</button>
                <button @click="onProcess()" :class="'rounded-md text-white hover:bg-costeaPrimary hover:text-white duration-100 ease-in px-2 py-3 cursor-pointer w-36 box-border text-t14 uppercase tracking-wide ' + buttonBg" type="submit">{{buttonText}}</button>
            </div>
        </form>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import {mapState} from 'vuex'
export default {
    data(){
        return{
            gastoNombre: '',
            gastoMensual: '',
            buttonText: 'Actualizar',
            buttonBg: 'bg-costeaPrimary',
            modalAct : true
        }
    },
    mounted(){
    
    },
    computed:{...mapState(['costea'])},
    props:{
        gastoOld: String,
        idGasto: Number
    },
    methods:{
        
        setGastos: function(){
          axios
          .post(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}gasto-update/${this.idGasto}`, {nombre_gasto: this.gastoNombre, gasto_mensual: this.gastoMensual, fecha_de_estudio: moment().format('YYYY-MM-DD')})
            .then(()=>{
                setTimeout(()=>{
                    this.buttonText = 'Listo!'
                    this.buttonBg = 'bg-costeaDarkGreen'
                    this.gastoNombre = ''
                },100)
                setTimeout(()=>{
                 this.toggleModal()
                },1000)
                setTimeout(()=>{
                    this.buttonText = 'Editar'
                    this.buttonBg = 'bg-costeaPrimary'
                },3000)
            }
            ).catch (
                (error) => {
                  console.log(error)
                }
            );
      },
        modalActive(){
            this.modalAct = true
            this.modalAct == true ? this.modalAct = false : this.modalAct = true
            return this.modalAct
        },
        toggleModal(){
            this.$emit('closeModalEdit', this.modalActive())
            this.$emit('reloadData', true)
        },
        onProcess(){
            this.buttonText = 'Editando...'
        }
    }
}
</script>

<style scoped>
    .addmodal{
        background: rgba(0, 0, 0, 0.6);
    }
</style>